import apiHelperService from '@/services'
import { useFormStore } from '@/stores/form'

export default function () {
  return {
    emirateIdFormateMethod: async (value, item) => {
      const formStore = useFormStore()
      if (!formStore.extraMap.emiratesCache) {
        formStore.extraMap.emiratesCache = await apiHelperService.get(`/api/lookup/emirates`)
      }
      return formStore.extraMap.emiratesCache?.find((i) => i.id == value)?.text || value
    },
    cityIdFormateMethod: async (value, item, currentRow) => {
      const formStore = useFormStore()
      if (!formStore.extraMap.cityCache) {
        formStore.extraMap.cityCache = await apiHelperService.get(
          `/api/lookup/citiesEida/${currentRow.emirateId}`
        )
      }
      return formStore.extraMap.cityCache?.find((i) => i.id == value)?.text || value
    },
    cityZoneIdFormateMethod: async (value, item) => {
      const formStore = useFormStore()
      if (!formStore.extraMap.cityZonesCache) {
        formStore.extraMap.cityZonesCache = await apiHelperService.get(
          `/api/lookup/getAllCityZones`
        )
      }
      return formStore.extraMap.cityZonesCache?.find((i) => i.id == value)?.text || value
    }
  }
}
